import React, { useState, useEffect, useMemo, useContext } from 'react';
import { CrudMasterDetailView, GridView, CrudContext, CompositeView, notification, Widget } from '@digital/ui';
import { getAllProjetoRelatorioRpp } from '@app/api/projeto';
import { hasPermission } from '@app/helpers/permissions';
import TabelaProjetoOverviewResumo from '@app/views/Dashboard/ProjectsOverview/tabelaProjetoOverviewResumo';
import { getAllProjetoOverView, TabelaProjetoOverViewResult } from '@app/api/tabelaProjetoOverView';
import ProjetoOverView from './projetoOverView';


const RelatorioProjectsOverview = () => {
  const [projetos, setProjetos] = useState(() => getAllProjetoRelatorioRpp);
  const [resultProjetoOverView, setResultProjetoOverView] = useState<TabelaProjetoOverViewResult[]>();
  const idTodos = '00000000-0000-0000-0000-000000000000';
  const urlTodosProjeto =
    '/relatorioProjectsOverview/detail/00000000-0000-0000-0000-000000000000/detalhe';
  const idAbaGeral = 'dadosGerais';

  const getValueUrl = () => {
    const latUrl = window.location.pathname.split('/').pop();
    if (latUrl === idAbaGeral) {
      const ulr = window.location.origin;
      const urlFinal = `${ulr}${urlTodosProjeto}`;
      window.location.href = urlFinal;
    }
  };

  useEffect(() => {
    getAllProjetoOverView().then((data) => {
      if (data)
        setResultProjetoOverView(data);
    });
  }, [])

  return (
    <CrudMasterDetailView
      getAllItems={projetos}
      filterPredicate={(item, value) =>
        (item.codigo && item.codigo.toLowerCase().includes(value.toLowerCase())) ||
        (item.statusNome && item.statusNome.toLowerCase().includes(value.toLowerCase())) ||
        (item.numero && item.numero.toLowerCase().includes(value.toLowerCase())) ||
        item.nome.toLowerCase().includes(value.toLowerCase())
      }
      titleExtractor={item => (item.id === idTodos ? `${item.nome}` : `${item.codigo} - ${item.nome}`)}
      descriptionExtractor={item => item.statusNome || ''}>
      <CrudContext.Consumer>
        {({ selectedItem }) => {
          if (selectedItem && selectedItem.id === idTodos) {
            getValueUrl();
            return (
              <CompositeView>
                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id={`detalhe`} noform title="PROJECTS | APPROVED">
                    <TabelaProjetoOverviewResumo
                      dataSourceResult={resultProjetoOverView}
                      telaFechamento={false}
                    />
                  </GridView>
                ) : (
                  () => { }
                )}
              </CompositeView>
            );
          } else {
            return (
              <CompositeView>
                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id={`detalhe`} noform title="DADOS GERAIS">
                    <ProjetoOverView selectedItem={selectedItem} />
                  </GridView>
                ) : (
                  () => { }
                )}
              </CompositeView>
            );
          }
        }}
      </CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default RelatorioProjectsOverview;
